import React from 'react'
import { Select, formatSelectOptions } from '../../../../components'

// Compact pill editor for a person's relation tags — used both as the
// "shared defaults for all rows" and per-row editor in BulkPersonImport.
// Operates on a plain array of relation_type_ids (no live API calls, unlike
// PersonDetail's curated-relations UI which this is modeled on).
export const RelationTagsEditor = ({ relationTypes, selectedIds, onChange }) => {
  const selected = relationTypes.filter(rt => selectedIds.includes(rt.relation_type_id))
  const available = relationTypes.filter(rt => !selectedIds.includes(rt.relation_type_id))

  const removeTag = (relationTypeId) => {
    onChange(selectedIds.filter(id => id !== relationTypeId))
  }

  return (
    <div className="relation-tags-editor">
      <div className="pill-list">
        {selected.map(rt => (
          <span key={rt.relation_type_id} className="pill">
            {rt.relation_type_name}
            <button type="button" className="button-icon" title="Ta bort" onClick={() => removeTag(rt.relation_type_id)}>✕</button>
          </span>
        ))}
      </div>
      {available.length > 0 &&
        <Select
          name="addingRelationTag"
          value=""
          placeholder="+ Lägg till"
          options={formatSelectOptions({ options: available, optionValue: 'relation_type_id', optionLabel: 'relation_type_name' })}
          onChange={({ value }) => value && onChange([...selectedIds, Number(value)])}
        />
      }
    </div>
  )
}
